import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { TruthSection } from './components/TruthSection';
import { MechanismSection } from './components/MechanismSection';
import { TransformationSection } from './components/TransformationSection';
import { WhatIncluded } from './components/WhatIncluded';
import { WhoIsItFor } from './components/WhoIsItFor';
import { PricingCTA } from './components/PricingCTA';
import { ClosingSection } from './components/ClosingSection';
import { FloatingCTA } from './components/FloatingCTA';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen w-full bg-[#FDF8F0]" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainSection data-id="element-2" />
      <TruthSection data-id="element-3" />
      <MechanismSection data-id="element-4" />
      <TransformationSection data-id="element-5" />
      <WhoIsItFor data-id="element-6" />
      <PricingCTA data-id="element-7" />
      <ClosingSection data-id="element-8" />
      <Footer data-id="element-9" />
      <FloatingCTA data-id="element-10" />
    </main>;
}